const trimTrailingSlash = (value) => String(value || '').replace(/\/+$/, '');

const isDevelopment = process.env.NODE_ENV === 'development';

export const API_URL = trimTrailingSlash(isDevelopment
  ? (process.env.REACT_APP_DEV_API_URL || 'http://127.0.0.1:50003')
  : 'https://pandoras-box.salew-bot.ru');

export const WS_URL = trimTrailingSlash(isDevelopment
  ? (process.env.REACT_APP_DEV_WS_URL || 'ws://127.0.0.1:1825')
  : 'wss://pandoras-box.salew-bot.ru');

export const PUBLIC_URL = trimTrailingSlash(isDevelopment
  ? (process.env.REACT_APP_DEV_PUBLIC_URL || 'http://127.0.0.1:3000')
  : 'https://salew-bot.ru');
